import { render, staticRenderFns } from "./Home-fr.vue?vue&type=template&id=5db041b0&"
import script from "./Home-fr.vue?vue&type=script&lang=js&"
export * from "./Home-fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports